module.exports = __webpack_public_path__ + "img/hx.da0662b8.png";